var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import i18n from '@/i18n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { SkillCategory, SkillCategoryIncludes } from '@/models/SkillCategory';
let AddSkillSetDialog = class AddSkillSetDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.payload = {
            skillSet: '',
        };
        this.skillSets = null;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchSkillSets();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onClose() {
        this.$emit('close');
    }
    onSubmit() {
        if (!this.isValid) {
            return;
        }
        this.$emit('submitted', this.payload);
    }
    // #endregion
    // #region Class methods
    reset() {
        this.payload.skillSet = '';
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchSkillSets() {
        const skillSets = await new SkillCategory().include([SkillCategoryIncludes.SKILLS]).all();
        // Remove Empty sets and sets that are excluded
        this.skillSets = skillSets.filter((skillSet) => {
            return !!(skillSet.skills && skillSet.skills.length);
        });
        if (this.existingSkillSets && this.existingSkillSets.length > 0) {
            this.skillSets = this.skillSets.filter((skillSet) => {
                return !this.existingSkillSets.some((existingSkillSet) => existingSkillSet.id === skillSet.id);
            });
        }
    }
    // #endregion
    // #region Getters & Setters
    get isValid() {
        return this.payload.skillSet.length > 0;
    }
};
__decorate([
    Prop({ default: i18n.tc('Select skill set') }),
    __metadata("design:type", String)
], AddSkillSetDialog.prototype, "title", void 0);
__decorate([
    Prop({ default: i18n.tc('Assign a new skill set.') }),
    __metadata("design:type", String)
], AddSkillSetDialog.prototype, "description", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", Array)
], AddSkillSetDialog.prototype, "existingSkillSets", void 0);
AddSkillSetDialog = __decorate([
    Component({
        components: {
            SelectFilter,
        }
    })
], AddSkillSetDialog);
export default AddSkillSetDialog;
// #endregion
// #region Constants
// #endregion
